<template>
  <div class="feeInfoWrapper">
    <payment-info/>
    <div class="feeInfoContentWrapper">
      <div class="feeInfoHeader">
        <div class="largeHeadLine">충전 및 광고비 현황</div>
        <div class="pointInfoWrapper">
          <div class="pointInfoDiv">
            <span class="itemName">보유포인트</span>
            <span class="nowPointValue">{{adPoint.toLocaleString() + '원'}}</span>
          </div>
          <input type="button" class="chargePointButton" value="포인트 충전" v-on:click="setPaymentInfo">
        </div>
        <div class="sectionLine"></div>
        <div class="dateInputWrapper">
          <feeInfo-date-input v-bind:type="'startAt'"></feeInfo-date-input>
          <span>&nbsp;&nbsp;~&nbsp;&nbsp;</span>
          <feeInfo-date-input v-bind:type="'endAt'"></feeInfo-date-input>
          <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <input type="button" class="searchBtn" value="조회" v-on:click="onSearch">
        </div>
      </div>
      <div class="feeInfoTableWrapper">
        <div class="feeInfoTableHeader">
          <div>날짜</div>
          <div>제목</div>
          <div>포인트</div>
        </div>
        <div class="feeInfoTableDiv">
          <div class="feeInfoTable" v-for="(row, index) in tableData.rows" v-bind:key="index">
            <div>{{row.loggingDate.split(' ')[0]}}</div>
            <div>{{row.adTitle}}</div>
            <div>{{row.amount.toLocaleString() + '원'}}</div>
          </div>
          <div class="feeInfoNoDataDiv" v-show="tableData.rows.length === 0">
            <span>내역이 없습니다.</span>
          </div>
        </div>
      </div>
      <div class="feeInfoFooter">
        <div class="sectionLine"></div>
        <span class="itemName">총 포인트</span>
        <br>
        <span class="calPointValue">{{tableData.totalPoint.toLocaleString() + '원'}}</span>
      </div>
    </div>
    <board-footer></board-footer>
  </div>
</template>

<script>
import feeInfoDateInput from '../../board/elements/feeInfoDateInput.vue'
import boardFooter from '../elements/boardFooter'
import { VueGoodTable } from 'vue-good-table'
import 'vue-good-table/dist/vue-good-table.css'
import store from '../../../store'
import paymentInfoModal from '../elements/paymentInfoModal'

export default {
  components: {
    'feeInfo-date-input': feeInfoDateInput,
    'vue-good-table': VueGoodTable,
    'board-footer': boardFooter,
    'payment-info': paymentInfoModal
  },
  data () {
    return {
      adPoint: 0,
      tableData: {
        rows: [],
        totalPoint: 0
      }
    }
  },
  methods: {
    setTableData: function (listData) {
      let totalPoint = 0
      for(var i = 0; i < listData.length; i++) {
        totalPoint += listData[i].amount
      }
      this.tableData.rows = listData
      this.tableData.totalPoint = totalPoint
    },
    setAdPoint: function (adPoint) {
      this.adPoint = adPoint
    },
    onSearch: async function () {
      let feeInfoResponse = await store.dispatch('feeInfoListApi')
      this.setTableData(feeInfoResponse.data.data)
    },
    setPaymentInfo: function () {
      this.$modal.show('paymentInfo')
    }
  },
  async beforeRouteEnter (to, from, next) {
    try {
      let feeInfoResponse = await store.dispatch('feeInfoListApi')
      await store.dispatch('adUserInfoApi')
      next(vm => {
        vm.setAdPoint(store.getters.getAdUserStateValue('adPoint'))
        vm.setTableData(feeInfoResponse.data.data)
      })
    }catch (error) {
      console.log(error.response)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import '../../../assets/css/board.css';
.feeInfoWrapper{
  display : -webkit-flex;
  display : flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: white;
  margin: 0;
  padding: 0;
  flex: 0.97;
}

.feeInfoContentWrapper {
  display : -webkit-flex;
  display : flex;
  flex-direction: column;
  height: calc(100% - 82px);
}

.feeInfoHeader{
  display : -webkit-flex;
  display : flex;
  flex-direction: column;
  height: 304px;
  padding: 0 32px 0px 32px;
}

.pointInfoWrapper{
  display : -webkit-flex;
  display : flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  padding-bottom: 24px;
}

.pointInfoWrapper > .chargePointButton{
  cursor: pointer;
  border-radius: 8px;
  border: none;
  outline: none;
  font-size: 15px;
  font-weight: bold;
  width: 200px;
  height: 48px;
  color: white;
  background-color: rgb(0,153,255);
  flex: 0.15;
}

.pointInfoDiv{
  display : -webkit-flex;
  display : flex;
  align-items: flex-end;
  flex: 0.3;
}

.pointInfoDiv .itemName{
  font-size: 15px;
  color: rgb(0,153,255);
  margin-right: 30px;
}

.pointInfoDiv .nowPointValue{
  font-size: 20px;
  font-weight: bold;
  padding: 0;
  margin-right: 10px;
}

.dateInputWrapper{
  display : -webkit-flex;
  display : flex;
  align-items: center;
  padding-top: 24px;
}

.searchBtn{
  cursor: pointer;
  border-radius: 8px;
  border: rgb(0,153,255) 2px solid;
  text-align: center;
  outline: none;
  width: 72px;
  height: 48px;
  font-size: 13px;
  color: rgb(0,153,255);
  background-color: white;
}

.feeInfoTableWrapper{
  display : -webkit-flex;
  display : flex;
  flex-direction: column;
  padding: 0px 32px 5px 32px;
  flex: auto;
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.feeInfoTableWrapper::-webkit-scrollbar{
  display: none;
}

.feeInfoTableWrapper > .feeInfoTableHeader{
  display : -webkit-flex;
  display : flex;
  color: rgb(0,153,255);
  padding: 0;
  font-size: 11px;
}

.feeInfoTableDiv{
  overflow-y: auto;
  flex: 1;
}

.feeInfoTable{
  display : -webkit-flex;
  display : flex;
  padding: 0;
  font-size: 11px;
}

.feeInfoTableHeader > div:nth-child(2n + 1), .feeInfoTable > div:nth-child(2n + 1){
  text-align: center;
  vertical-align: middle;
  padding: 12px;
  flex: 0.15;
  border-bottom: rgb(172,172,172) solid 1px;
}

.feeInfoTableHeader > div:nth-child(2n), .feeInfoTable > div:nth-child(2n){
  text-align: left;
  vertical-align: middle;
  padding: 12px;
  flex: 0.7;
  border-bottom: rgb(172,172,172) solid 1px;
}

.feeInfoFooter{
  padding: 0 32px;
  text-align: right;
  height: 66px;
}

.feeInfoFooter .itemName{
  font-size: 11px;
  color: rgb(0,153,255);
}

.feeInfoFooter .calPointValue{
  font-size: 11px;
  font-weight: bold;
}

.feeInfoNoDataDiv {
  text-align: center;
  height: 100px;
  font-size: 11px;
  padding-top: 50px;
  color: #707070;
}
</style>



// WEBPACK FOOTER //
// src/components/board/views/feeInfo.vue